import {
  Box,
  Card,
  CardContent,
  Grid,
  TextField,
  Typography
} from '@mui/material';

export const OrderInfo = ({ data }) => {
  const Spacer = () => <Box m={1}>&nbsp;</Box>;
  const dateTimeString = `${new Date(data.transaction_time).toDateString()}, ${new Date(data.transaction_time).toLocaleTimeString()}`;

  const sharedProps = {
    InputProps: {
      readOnly: true,
      disableUnderline: true,
    },
    variant: "standard",
    fullWidth: true,
    sx: {
      '& .MuiInput-underline:before': { borderBottom: 'none' },
      '& .MuiInput-underline:after': { borderBottom: 'none' },
    },
  };

  return (
      <Card>
        <CardContent>
          <Grid container>
            <Typography variant="h4" gutterBottom>
              Receipt #{data.id}
            </Typography>
          </Grid>
          <Spacer />

          <Box
              display="grid"
              gridTemplateColumns="1fr"
              gap="24px"
          >
            <Grid item xs={12}>
              <TextField
                  id="reference"
                  label="Reference"
                  defaultValue={data?.reference_id}
                  {...sharedProps}
              />
            </Grid>

            <Grid item xs={12}>
              <TextField
                  id="status"
                  label="Status"
                  defaultValue={data?.status}
                  {...sharedProps}
              />
            </Grid>

            <Grid item xs={12}>
              <TextField
                  id="time-of-the-transaction"
                  label="Date"
                  defaultValue={dateTimeString}
                  {...sharedProps}
              />
            </Grid>

            <Grid item xs={12}>
              <TextField
                  id="event"
                  label="Event"
                  defaultValue={data.event?.name}
                  {...sharedProps}
              />
            </Grid>

            <Grid item xs={12}>
              <TextField
                  id="location"
                  label="Location"
                  defaultValue={data.location?.name}
                  {...sharedProps}
              />
            </Grid>
          </Box>
        </CardContent>
      </Card>
  );
};
